export default __webpack_public_path__ + "static/media/document-icon.3da7184d.svg";